module.exports = __webpack_public_path__ + "img/1.49f0424f.png";